import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom";
//import { useDispatch } from "react-redux";
import { oktaAuth } from "./authConfig";
//import { getUser } from "../actions/user";

export default function RequiredAuth({ children }) {
    const { authState } = useOktaAuth();
    const navigate = useNavigate()

    useEffect(() => {
        const navigateToUnauthorizedPage = () => navigate('/unauthorized')
        window.addEventListener('user_not_enable', navigateToUnauthorizedPage)
        return () => {
            window.removeEventListener('user_not_enable', navigateToUnauthorizedPage)
        }
    }, [navigate])

    useEffect(() => {
        const expiredToken = () => {
            if (localStorage.getItem('refreshToken')) {
                localStorage.clear()
                navigate('/login')
            } else localStorage.setItem('refreshToken', 'true')
            window.location.reload()
        }
        window.addEventListener('token_expired', expiredToken)

        return () => {
            window.removeEventListener('token_expired', expiredToken)
        }
    }, [navigate])

    useEffect(() => {
        const invalidToken = () => oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + '/logout/callback' })
        window.addEventListener('invalid_token', invalidToken)
        return () => {
            window.removeEventListener('invalid_token', invalidToken)
        }
    }, [navigate])

    useEffect(() => {
        if (!authState) {
            return
        }

        if (!authState?.isAuthenticated) {
            oktaAuth.signInWithRedirect({ originalUri: '/' })
        }
    }, [authState?.isAuthenticated, authState])

    return (
        <div>
            {children}
        </div>
    )
}

export const getTranslationByKey = (key) => {
    let translation = ''
    let translation_en = ''
    if (sessionStorage.getItem('translation')) {
        translation = JSON.parse(sessionStorage.getItem('translation'))
        translation_en = JSON.parse(sessionStorage.getItem('translation_en'))
        return translation[key] && translation[key].v ? translation[key].v : (translation_en[key] && translation_en[key].v ? translation_en[key].v : key)
    } else {
        return key
    }
}
export const setSessionStorageInfo = (val, value, jsonFile) => {
    let lang = navigator.language.split('-')[0]
    sessionStorage.setItem('translations', JSON.stringify(val));
    if (localStorage.getItem("selectedLanguage"))
        lang = localStorage.getItem("selectedLanguage")
    if (val[lang])
        sessionStorage.setItem('translation', JSON.stringify(val[lang].main.entries))
    else {
        sessionStorage.setItem('translation', JSON.stringify(val["en"].main.entries))
    }
    sessionStorage.setItem('translation_en', JSON.stringify(val['en'].main.entries))
    sessionStorage.setItem('jsonFile', jsonFile);
}
